import { useIdleTimer } from './services/IdleTimer.hooks';

export default function IdleTimer() {
  useIdleTimer();

  return null;
}
